import { render, staticRenderFns } from "./SellingData.vue?vue&type=template&id=19fade86&scoped=true&"
import script from "./SellingData.vue?vue&type=script&lang=js&"
export * from "./SellingData.vue?vue&type=script&lang=js&"
import style0 from "./SellingData.vue?vue&type=style&index=0&id=19fade86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fade86",
  null
  
)

export default component.exports